import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {MAPS_TYPES_ENUM} from '../../editor-interface/shared/models/map.model';

export interface IMap {
  id?: string;
  name?: string;
  type?: MAPS_TYPES_ENUM;
  copyEnabled?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MapService {
  mapSubject: BehaviorSubject<IMap> = new BehaviorSubject<IMap>({});

  public map$: Observable<IMap> = this.mapSubject.asObservable();
  public isSFA$: Observable<boolean> = this.map$.pipe(
    map(json => this.isSFA(json)),
    shareReplay()
  );

  constructor() {}

  setup({map}: {map: IMap}) {
    this.mapSubject.next(map);
  }

  public isSFA(jsonMap?): boolean {
    const json = jsonMap || this.mapSubject.getValue();

    return json?.type === MAPS_TYPES_ENUM.ARCHITECTURE;
  }

  get mapType(): MAPS_TYPES_ENUM {
    return this.mapSubject.getValue()?.type;
  }
}
